import { get, post, put, del } from '../../utils/http';
import * as constants from './billing-constants';

const getCompanyURL = (getState) => {
  const { company: { companyId } } = getState().user.toJS();
  return `/proxy/company/${companyId}`;
};

const isLoading = (loading = false) => (
  {
    type: 'BILLING_LOADING',
    loading,
  }
);

const billingError = (message) => (
  {
    type: 'BILLING_ERROR',
    payload: {
      message,
    },
  }
);

const addSubscriptionFail = ({ message }) => dispatch => {
  dispatch(billingError(message));
};

const updatePaymentSourceFail = ({ message }) => dispatch => {
  dispatch(billingError(message));
};

const addSubscriptionSuccess = data => dispatch => {
  dispatch({ type: 'USER_STORE_PLAN_UPDATE', payload: { plan: data.plan } });
  dispatch({ type: 'GET_BILLING', payload: data });
};

const deleteSubscriptionSuccess = () => (
  {
    type: 'CANCEL_SUBSCRIPTION',
    payload: {},
  }
);

export const resetBillingError = () => (
  {
    type: 'RESET_BILLING_ERROR',
  }
);

export const addSubscription = (planId, tokenId, card) => (dispatch, getState) => {
  const body = {
    planId,
    tokenId,
    card,
  };
  const billing = getState().billing.toJS();
  if (billing && billing.coupon &&
  billing.coupon.name) {
    body.coupon = billing.coupon.name;
  }

  dispatch(isLoading(true));
  return post(`${getCompanyURL(getState)}/subscription`, body)
    .then(
      response => response.json()
      .then(
        data => ({ data, response })
      )
    ).then(({ data, response }) => {
      dispatch(isLoading(false));
      if (!response.ok) {
        dispatch(addSubscriptionFail(data));
        return Promise.reject();
      }
      dispatch(addSubscriptionSuccess(data));
      return Promise.resolve();
    });
};

export const cancelSubscription = (reason, addtionalDetail) => (dispatch, getState) => {
  dispatch(isLoading(true));
  post(`${getCompanyURL(getState)}/subscription/delete`, { reason, addtionalDetail })
    .then(response => {
      if (!response.ok) {
        dispatch(isLoading(false));
        dispatch(billingError(response.error));
      } else {
        dispatch(isLoading(false));
        dispatch(deleteSubscriptionSuccess());
      }
    })
    .catch(
      err => console.log('Error: ', err)  // eslint-disable-line no-console
    );
};

export const updatePaymentSource = (token) => (dispatch, getState) => {
  dispatch(isLoading(true));
  return put(`${getCompanyURL(getState)}/billing/source`, { token })
  .then(
    response => response.json()
    .then(
      data => ({ data, response })
    )
  ).then(({ data, response }) => {
    dispatch(isLoading(false));
    if (!response.ok) {
      dispatch(updatePaymentSourceFail(data));
      return Promise.reject(new Error(data));
    } else {
      dispatch({ type: constants.GET_BILLING, payload: data });
      return Promise.resolve();
    }
  });
};

export const getCoupon = (couponName) => (dispatch, getState) => {
  return get(`/proxy/coupon/${couponName}`)
  .then(
    response => response.json()
    .then(
      data => ({ data, response })
    )
  ).then(({ data, response }) => {
    dispatch(isLoading(false));
    if (!response.ok) Promise.reject();

    return dispatch({ type: constants.GET_COUPON, payload: data });
  });
};

export const getBilling = () => (dispatch, getState) => {
  dispatch(isLoading(true));
  return get(`${getCompanyURL(getState)}/billing`)
  .then(
    response => response.json()
    .then(
      data => ({ data, response })
    )
  ).then(({ data, response }) => {
    dispatch(isLoading(false));
    if (!response.ok) {
      dispatch({ type: 'BILLING_ERROR', payload: data });
    } else {
      dispatch({ type: constants.GET_BILLING, payload: data });
    }
  });
};



// WEBPACK FOOTER //
// ./src/app/stores/billing/billing-actions.js